
const b64enc = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
const b64dec = (b64) => Uint8Array.from(atob(b64), c => c.charCodeAt(0));

async function getPublicKey() {
    const pem = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2MmqO1HGj0Pvl0vfLxlS
    JtEo9OBmWB0dS98TM8TOcZHFK9zfP4oCccSmOu21lIeUMQPdEOIceDONIOqmbFmc
    bslFB3m6YuYtp7kHbPMKFBJQXpEC4DmZFoGESxF4vGBVbO6UhYcO/Pr1b2g4eX2Q
    magn9Fd9O90mbaaS1pYXps8BkF0CJYexlHfOCTUTfXPKlbTW8WnPhBikdjun1cBs
    GtMenNXTRTi1Sh5qr7GjLYLVsj1es/gav/QGlkmEoWzQl/bgYXnCuUFyEyOBjglB
    k3xeyNagdR8C/ncehDOeevtvD8wNm/OHACA3Hu0KKFdi8gFQRAbVIeLC5RPMQdB7
    7QIDAQAB
    -----END PUBLIC KEY-----`;
    const b64 = pem.replace(/-----.*?-----/g, '').replace(/\s+/g, '');
    const raw = b64dec(b64).buffer;
    return crypto.subtle.importKey('spki', raw, { name: 'RSA-OAEP', hash: 'SHA-256' }, false, ['encrypt']);
}

// encrypt payload (card JSON)
export async function encryptCardPayload(cardObj) {
    // 1. fetch PEM public key from server
    const rsaPubKey = await getPublicKey();

    // 2. generate AES-GCM key (256 bits)
    const aesKey = await crypto.subtle.generateKey(
        { name: "AES-GCM", length: 256 },
        true, // extractable because we will export raw key to encrypt with RSA
        ["encrypt", "decrypt"]
    );

    // 3. export raw AES key to encrypt it with RSA
    const rawAesKey = await crypto.subtle.exportKey("raw", aesKey); // ArrayBuffer

    // 4. encrypt the AES key with RSA-OAEP
    const encryptedKeyBuf = await crypto.subtle.encrypt(
        { name: "RSA-OAEP" },
        rsaPubKey,
        rawAesKey
    );

    // 5. encrypt the data with AES-GCM
    const iv = crypto.getRandomValues(new Uint8Array(12)); // 96-bit IV recommended
    const encoder = new TextEncoder();
    const plaintext = encoder.encode(JSON.stringify(cardObj));

    // cipherBuf contains ciphertext + auth tag (appended)
    const cipherBuf = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv: iv, tagLength: 128 },
        aesKey,
        plaintext
    );

    // 6. return base64 payload pieces
    return {
        encryptedKey: b64enc(encryptedKeyBuf),
        iv: b64enc(iv.buffer),
        ciphertext: b64enc(cipherBuf)
    };
}
